import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/app/app";
import "@/styles/globals.css";

const VITE_PRELOAD_RETRY_KEY = "fanvault-vite-preload-retry";
const VITE_ASSET_RETRY_KEY = "fanvault-asset-retry";

function reloadOnceForAssetFailure() {
  if (typeof window === "undefined") {
    return;
  }

  const retryKey = `${VITE_ASSET_RETRY_KEY}:${window.location.pathname}`;
  if (window.sessionStorage.getItem(retryKey) === "1") {
    window.sessionStorage.removeItem(retryKey);
    return;
  }

  window.sessionStorage.setItem(retryKey, "1");
  window.location.reload();
}

if (typeof window !== "undefined") {
  window.addEventListener("vite:preloadError", (event) => {
    const currentKey = `${VITE_PRELOAD_RETRY_KEY}:${window.location.pathname}`;
    if (window.sessionStorage.getItem(currentKey) === "1") {
      window.sessionStorage.removeItem(currentKey);
      return;
    }

    window.sessionStorage.setItem(currentKey, "1");
    event.preventDefault();
    window.location.reload();
  });

  window.addEventListener(
    "error",
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLScriptElement)) {
        return;
      }

      const source = target.src || "";
      if (!/\/assets\/.+\.js(?:\?.*)?$/i.test(source)) {
        return;
      }

      reloadOnceForAssetFailure();
    },
    true,
  );

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const input = args[0];
    const url = typeof input === "string" ? input : input instanceof Request ? input.url : "";

    if (response.status === 404 && /\/assets\/.+\.(js|css)(?:\?.*)?$/i.test(url)) {
      reloadOnceForAssetFailure();
    }

    return response;
  };
}

ReactDOM.createRoot(document.getElementById("app")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
